<template>
  <div class="flex flex-col items-start gap-2 my-2">
    <wui-checkbox
      v-for="weekday in weekdays"
      :key="weekday.value"
      v-model="weekday.checked"
      class="text=label-r-13-18 text-fg-base-fg10"
      primary
    >
      <span class="text-1316">
        {{ weekday.label }}
      </span>
    </wui-checkbox>
  </div>
</template>

<script lang="ts" setup>
import { WuiCheckbox } from '@wui/common-library'
import dayjs from 'dayjs'
import { ref, toRef, watch, onBeforeMount } from 'vue'

import { useLocalization } from '@/shared/composables/localization'

const props = defineProps<{
  modelValue: number[]
}>()
const model = toRef(props, 'modelValue')

const emit = defineEmits<{
  (e: 'update:modelValue', value: number[]): void
}>()

const { t } = useLocalization()

type WeekdayOption = { value: number, label: string, checked: boolean }

const weekdays = ref<WeekdayOption[]>([{
  value: 1,
  label: t('common.monday'),
  checked: model.value.includes(1),
},
{
  value: 2,
  label: t('common.tuesday'),
  checked: model.value.includes(2),
},
{
  value: 3,
  label: t('common.wednesday'),
  checked: model.value.includes(3),
},
{
  value: 4,
  label: t('common.thursday'),
  checked: model.value.includes(4),
},
{
  value: 5,
  label: t('common.friday'),
  checked: model.value.includes(5),
},
{
  value: 6,
  label: t('common.saturday'),
  checked: model.value.includes(6),
},
{
  value: 7,
  label: t('common.sunday'),
  checked: model.value.includes(7),
}])

watch(weekdays, () => {
  emit('update:modelValue', weekdays.value.filter(w => w.checked).map(w => w.value))
}, { deep: true })

onBeforeMount(() => {
  if (!model.value.length) {
    const currentWeekdayNum = dayjs().day()
    emit('update:modelValue', [currentWeekdayNum])
    const weekday = weekdays.value.find(w => w.value === currentWeekdayNum)
    if (weekday) {
      weekday.checked = true
    }
  }
})
</script>
